export default {
  app: {
    title: "صندوق مفردات الأحلام",
    language: "العربية"
  },

  pages: {
    app: {
      myAccount: "حسابي",
      editProfile: "تعديل الملف الشخصي",

      boxScenarios: "سيناريوهات الصناديق",
      scenario1Title: "صندوق نصف يوم",
      scenario1Desc: "راجع الصندوق كل نصف يوم (مثلاً صباحاً ومساءً).",

      scenario2Title: "الصندوق اليومي",
      scenario2Desc: "راجع الصندوق مرة واحدة يومياً.",

      scenario3Title: "بعدد أيام الصندوق",
      scenario3Desc: "تتم مراجعة الصندوق حسب رقمه (مثلاً الصندوق 3 كل 3 أيام).",

      username: "اسم المستخدم",
      usernameHint: "اسم المستخدم الفريد الخاص بك لتسجيل الدخول",

      name: "الاسم",
      nameHint: "كيف تحب أن نناديك؟",

      email: "البريد الإلكتروني",
      emailHint: "بريد إلكتروني لاستعادة كلمة المرور (اختياري)",

      changePassword: "تغيير كلمة المرور",
      changePasswordHint: "إذا كنت لا تريد تغيير كلمة المرور، اترك هذا الحقل فارغاً (اختياري)",

      logout: "تسجيل الخروج",
      confirmLogout: "تأكيد تسجيل الخروج",
      confirmLogoutText: "هل أنت متأكد أنك تريد تسجيل الخروج؟",
      cancel: "إلغاء",

      close: "إغلاق",
      updateProfile: "تحديث الملف الشخصي",

      myWords: "كلماتي",
      addNewWord: "إضافة كلمة/تعبير جديد",
      boxes: "الصناديق",

      applicationSettings: "إعدادات التطبيق",

      autoSpeechOnChecking: "تشغيل نطق الكلمة تلقائياً عند ظهورها",
      autoDetectClipboardChange: "اكتشاف نص الحافظة تلقائياً",

      clipboardPermissionText: "يحتاج التطبيق إلى إذن للوصول إلى الحافظة من إعدادات المتصفح. للمزيد من المساعدة، اضغط هنا.",

      clipboardHelpTitle: "كيفية تفعيل الوصول إلى الحافظة",

      chrome: "كروم",
      firefox: "فايرفوكس",
      safari: "سفاري",

      chromeStep1: "افتح متصفح كروم.",
      chromeStep2: "انتقل إلى إعدادات المتصفح.",
      chromeStep3: "ابحث عن إعدادات الموقع أو قسم الإعدادات.",
      chromeStep4: "انتقل إلى الأذونات وقم بتفعيل الحافظة.",

      firefoxStep1: "افتح متصفح فايرفوكس.",
      firefoxStep2: "انتقل إلى إعدادات المتصفح.",
      firefoxStep3: "ابحث عن قسم الأذونات وقم بتفعيل الوصول إلى الحافظة.",

      safariStep1: "افتح تطبيق الإعدادات في هاتفك.",
      safariStep2: "انتقل إلى سفاري.",
      safariStep3: "ابحث عن الإعدادات المتعلقة بالحافظة وقم بتفعيلها.",

      otherBrowserTitle: "إذا كنت تستخدم متصفحاً آخر",
      otherBrowserStep1: "ابحث عن خيار مشابه للأذونات أو إعدادات الموقع داخل إعدادات المتصفح وقم بتفعيل الوصول إلى الحافظة.",

      speechNotSupported: "متصفحك لا يدعم SpeechSynthesis",

      ttsSettings: "إعدادات تحويل النص إلى كلام",
      sampleText: "نص لاختبار النطق",

      rate: "السرعة",
      rateHint: "تتحكم في سرعة النطق.",

      pitch: "النبرة",
      pitchHint: "تضبط نبرة الصوت.",

      volume: "مستوى الصوت",
      volumeHint: "يضبط مستوى صوت النطق.",

      friends: "الأصدقاء",
      messages: "الرسائل",

      addToMyWords: "أضف {word} إلى كلماتي",
      viewInMyList: "عرض {word} في قائمتي",

      wordSuggestion: "اقتراح كلمة",
      goToAddWord: "الانتقال إلى إضافة كلمة جديدة",

      updateCompleted: "تم التحديث بنجاح",
      latestChanges: "أحدث التغييرات في الإصدارات الأخيرة",
      version: "الإصدار",
      gotIt: "حسناً"
    },

    addVocabulary: {
      title: "إضافة كلمة جديدة",
      add: "إضافة",
      word: "كلمة / عبارة",
      meaning: "المعنى",
      example: "مثال",
      description: "الوصف"
    },

    vocabularies: {
      searchLabel: "بحث نصي",
      listLength: "عدد العناصر",
      boxNumber: "رقم الصندوق",
      nothingFound: "لم يتم العثور على شيء !!!",
      adjustFilters: "يرجى محاولة تعديل عوامل التصفية",
      tableWord: "الكلمة",
      tableAction: "الإجراء",
      showDetails: "عرض التفاصيل",
      completeInfo: "معلومات كاملة",
      meaning: "المعنى",
      example: "مثال",
      description: "الوصف",
      close: "إغلاق",
      editTitle: "تعديل",
      editBtn: "تعديل",
      deleteTitle: "حذف {word}",
      deleteConfirmText: "هل أنت متأكد أنك تريد حذف هذه الكلمة؟ يرجى ملاحظة أنه بعد الحذف لا يمكن استعادتها.",
      yes: "نعم!",
      no: "لا"
    },

    messages: {
      wordSuggestions: "اقتراحات الكلمات"
    },

    login: {
      signInTitle: "تسجيل الدخول",
      signInBtn: "تسجيل الدخول",
      registerTitle: "إنشاء حساب",
      registerBtn: "إنشاء حساب",
      registerLink: "إنشاء حساب",
      username: "اسم المستخدم",
      password: "كلمة المرور",
      nickname: "الاسم",
      email: "البريد الإلكتروني",
      noAccount: "ألم تسجل بعد؟",
      haveAccount: "لدي حساب.",
      usernameHint: "اسم المستخدم الفريد الخاص بك لتسجيل الدخول",
      nicknameHint: "كيف تحب أن نناديك؟",
      emailHint: "بريد إلكتروني لاستعادة كلمة المرور (اختياري)",
      passwordHint: "كلمة مرور بدون قواعد، أدخل أي شيء تريده",
      orContinueWith: "أو المتابعة باستخدام...",
      guestRegister: "تسجيل سريع كضيف 😒"
    },

    reviewVocabulary: {
      showMeaning: "إظهار المعنى",
      hideMeaning: "إخفاء المعنى",
      meaning: "المعنى",
      example: "مثال",
      description: "الوصف",
      playPhrase: "PlayPhrase.me",
      prev: "السابق",
      next: "التالي"
    },

    checkVocabulary: {
      showMeaning: "إظهار المعنى",
      hideMeaning: "إخفاء المعنى",
      wordsRemain: "الكلمات المتبقية",
      lastOne: "الأخيرة",
      meaning: "المعنى",
      example: "مثال",
      description: "الوصف",
      playPhrase: "PlayPhrase.me",
      iRemember: "أتذكرها",
      iDontRemember: "لا أتذكرها"
    },

    boxes: {
      all: "عرض جميع الصناديق",
      box: "علبة",
      empty: "فارغ",
      needsChecking: "يحتاج إلى مراجعة",
      checked: "تمت مراجعته",

      total: "الإجمالي",
      waiting: "قيد الانتظار",
      waitingForCheck: "بانتظار المراجعة",

      closestReview: "أقرب مراجعة",
      notScheduled: "لم تتم جدولته بعد",

      deeplyMemorized: "لقد حفظت {count} كلمة جيداً.",
      notReachedYet: "عذراً! لم تصل إلى هذا الصندوق بعد.",

      startChecking: "بدء المراجعة",
      review: "مراجعة",
      viewAllWords: "عرض جميع الكلمات",
      addNew: "إضافة جديد",
      itsEmpty: "إنه فارغ"
    },

    friends: {
      searchInUsers: "البحث بين المستخدمين",
      searchList: "قائمة البحث",
      noUsersYet: "لا يوجد مستخدمون بعد.",
      searchUsersAndSendRequest: "يمكنك البحث عن المستخدمين وإرسال طلب صداقة",
      friendList: "قائمة الأصدقاء",
      noFriendsYet: "لا يوجد أصدقاء بعد."
    }
  },

  plugins: {
    axios: {
      postRequestError: "حدث خطأ أثناء إرسال الطلب"
    }
  },

  components: {
    shareButton: {
      shareTitle: "مشاركة {word}",
      messageOptional: "رسالة (اختياري)"
    },

    userList: {
      cancelRequest: "إلغاء الطلب",
      unfriend: "إلغاء الصداقة",
      sendRequest: "إرسال طلب",
      accept: "قبول",
      reject: "رفض",

      share: "مشاركة",
      addedBefore: "تمت إضافتها من قبل",

      deeplyMemorized: "لقد حفظ {name} عدد {count} كلمة جيداً.",
      notReachedBox: "لم يصل {name} إلى هذا الصندوق بعد.",

      totalVocabularies: "إجمالي الكلمات",
      registerAge: "مدة التسجيل",
      lastCheck: "آخر مراجعة",
      lastAddedVocabulary: "آخر كلمة تمت إضافتها",
      totalChecks: "إجمالي المراجعات",
      averageDailyCheck: "متوسط المراجعة اليومية",
      averageDailyLearnedCheck: "متوسط المراجعات اليومية المتعلمة",
      averageDailyNotLearnedCheck: "متوسط المراجعات اليومية غير المتعلمة",
      averageDailyAdd: "متوسط الإضافة اليومية"
    }
  },

  public: {
    close: "إغلاق"
  },
  "apiResultStatusCodes": {
    "0": "فشلت العملية",
    "1": "تمت العملية بنجاح",
    "2": "حدث خطأ",
    "3": "المعلمات المرسلة غير صالحة",
    "4": "غير موجود",
    "5": "خطأ في المصادقة",
    "6": "تم تسجيل هذا العنصر مسبقًا",
    "7": "تم تسجيل هذا المستخدم مسبقًا",
    "8": "المستخدم المحدد غير موجود",
    "9": "كلمة المرور غير صحيحة",
    "10": "المعلمات المرسلة غير صالحة",
    "11": "فشل تسجيل الدخول",
    "12": "تم رفض الوصول",
    "13": "العنصر غير موجود",
    "14": "اسم المستخدم هذا مستخدم بالفعل",
    "15": "البريد الإلكتروني مستخدم بالفعل",
    "16": "اسم المستخدم مطلوب",
    "17": "الاسم المستعار مطلوب",
    "18": "كلمة المرور مطلوبة",
    "19": "لا يمكن أن يحتوي اسم المستخدم على مسافات",
    "20": "تم التسجيل بنجاح",
    "21": "تم تسجيل الدخول بنجاح",
    "22": "لا يمكن أن تحتوي كلمة المرور على مسافات",
    "23": "تمت إضافة الكلمة بنجاح",
    "24": "تم تحديث الكلمة بنجاح",
    "25": "تم حذف الكلمة بنجاح",
    "26": "لقد أضفت هذه الكلمة بالفعل",
    "27": "الكلمة مطلوبة",
    "28": "لا توجد كلمات",
    "29": "تهانينا! تم التحقق من جميع الكلمات في هذا الصندوق",
    "30": "لا يمكنك تغيير حقل الكلمة",
    "31": "يرجى ملء الحقول المطلوبة",
    "32": "لم يتم العثور على تغييرات",
    "33": "المستخدم المحدد غير موجود في المستودع",
    "34": "تم إرسال طلب الصداقة بنجاح",
    "35": "تم قبول طلب الصداقة بنجاح",
    "36": "تم إلغاء طلب الصداقة بنجاح",
    "37": "تمت إزالة الصداقة بنجاح",
    "38": "تم رفض الطلب بنجاح",
    "39": "تم إرسال الرسالة بنجاح"
  },
  "time": {
    "day": "يوم | أيام",
    "hour": "ساعة | ساعات",
    "minute": "دقيقة | دقائق"
  }



}
